<template>

  <div class="topnav-wrap" v-click-outside-element="closeNav">
    <div class="topnav" @mouseleave="closeNav">
      
      <a href="https://selacloud.com" class="logo-wrap">
        <img src="../assets/logo.svg" alt="Sela. | Cloud Better." />
      </a>
      <a 
        href="/contact" 
        class="animated-button mobile-cta"
        @mouseenter="handleMouseEnter"
        @focusin="handleFocus"
        :style="{
          '--circle-x': `${circleX}%`,
          '--circle-y': `${circleY}%`
        }"
      >
        <span class="button-text">Get Started</span>
        <span class="button-arrow MaterialIcons">arrow_right_alt</span>
      </a>

      <!-- Mobile hamburger button -->
      <button @click="toggleMobileMenu" type="button" class="mobile-hamburger-btn">
        <div class="mobile-hamburger-lines">
          <span class="mobile-hamburger-line"></span>
          <span class="mobile-hamburger-line"></span>
          <span class="mobile-hamburger-line"></span>
        </div>
      </button>

      <!-- Mobile Menu Overlay -->
      <div class="mobile-menu-overlay" :class="{ 'mobile-menu-open': mobileMenuOpen }" @click="closeMobileMenu">
        <div class="mobile-menu-container" :class="{ 'mobile-menu-open': mobileMenuOpen }" @click.stop>
          
          <!-- Mobile Menu Header -->
          <div class="mobile-menu-header">
            <img src="../assets/logo.svg" alt="Sela" class="mobile-menu-logo" />
            <button type="button" class="mobile-close-btn" @click="closeMobileMenu">
              ✕
            </button>
          </div>

          <!-- Mobile Menu Content -->
          <div class="mobile-menu-content">
            
            <!-- Services -->
            <div class="mobile-nav-item">
              <button class="mobile-nav-button" :class="{ 'mobile-nav-active': activeMobileSection === 'services' }" @click="toggleMobileSection('services')">
                Services
                <div class="mobile-nav-arrow" :style="{ transform: activeMobileSection === 'services' ? 'rotate(-90deg)' : 'rotate(90deg)' }">
                  <img
                  src="../assets/chevron_right.svg"
                  alt="Arrow"
                ></div>
              </button>
              <div class="mobile-dropdown-content" :class="{ 'mobile-dropdown-open': activeMobileSection === 'services' }">
                <div class="mobile-dropdown-item" @click="navigateTo('/support')">
                  <div class="mobile-dropdown-title">Cloud Management Services</div>
                </div>
                <div class="mobile-dropdown-item" @click="navigateTo('/solutions/devops-as-a-service')">
                  <div class="mobile-dropdown-title">DevOps</div>
                </div>
                <div class="mobile-dropdown-item" @click="navigateTo('/solutions/security')">
                  <div class="mobile-dropdown-title">Security</div>
                </div>
                <div class="mobile-dropdown-item" @click="navigateTo('/solutions/cloud-architecture')">
                  <div class="mobile-dropdown-title">Cloud Architecture</div>
                </div>
                <div class="mobile-dropdown-item" @click="navigateTo('/solutions/cloud-migration')">
                  <div class="mobile-dropdown-title">Cloud Migration & Modernization</div>
                </div>
                <div class="mobile-dropdown-item" @click="navigateTo('/solutions/revolutionize-your-business-with-ai-cloud-services')">
                  <div class="mobile-dropdown-title">Data & AI</div>
                </div>
                <div class="mobile-dropdown-item" @click="navigateTo('/solutions/finops-as-a-service')">
                  <div class="mobile-dropdown-title">FinOps</div>
                </div>
                <div class="mobile-dropdown-item" @click="navigateTo('/solutions/monitoring-support-as-a-service')">
                  <div class="mobile-dropdown-title">Support & Monitoring Managed Services</div>
                </div>
                <div class="mobile-dropdown-item" @click="navigateTo('/solutions/delivery-professional-services-staff-augmentation')">
                  <div class="mobile-dropdown-title">Delivery: Staff Augmentation, Offshoring</div>
                </div>
                <div class="mobile-dropdown-item" @click="navigateTo('/skilling')">
                  <div class="mobile-dropdown-title">Skilling</div>
                </div>
              </div>
            </div>

            <!-- Solutions -->
            <div class="mobile-nav-item">
              <button class="mobile-nav-button" :class="{ 'mobile-nav-active': activeMobileSection === 'solutions' }" @click="toggleMobileSection('solutions')">
                Solutions
                <div class="mobile-nav-arrow" :style="{ transform: activeMobileSection === 'solutions' ? 'rotate(-90deg)' : 'rotate(90deg)' }">    <img
                  src="../assets/chevron_right.svg"
                  alt="Arrow"
                ></div>
              </button>
              <div class="mobile-dropdown-content" :class="{ 'mobile-dropdown-open': activeMobileSection === 'solutions' }">
                <div class="mobile-dropdown-item" @click="navigateTo('/solutions/genai-adoption')">
                  <div class="mobile-dropdown-title">GenAI Adoption Solution</div>
                </div>
                <div class="mobile-dropdown-item" @click="navigateTo('/solutions/ai-chatbot-company-data')">
                  <div class="mobile-dropdown-title">AI Chatbot over Company Data</div>
                </div>
                <div class="mobile-dropdown-item" @click="navigateTo('/solutions/marketplace')">
                  <div class="mobile-dropdown-title">Marketplace Solutions</div>
                </div>
                <div class="mobile-dropdown-item" @click="navigateTo('/solutions/landing-zones')">
                  <div class="mobile-dropdown-title">Landing Zones Solutions</div>
                </div>
              </div>
            </div>

            <!-- Resources -->
            <div class="mobile-nav-item">
              <button class="mobile-nav-button" :class="{ 'mobile-nav-active': activeMobileSection === 'resources' }" @click="toggleMobileSection('resources')">
                Resources
                <div class="mobile-nav-arrow" :style="{ transform: activeMobileSection === 'resources' ? 'rotate(-90deg)' : 'rotate(90deg)' }">
                  <img src="../assets/chevron_right.svg" alt="Arrow">
                </div>
              </button>
              <div class="mobile-dropdown-content" :class="{ 'mobile-dropdown-open': activeMobileSection === 'resources' }">
                <div class="mobile-dropdown-item" @click="navigateTo('/events')">
                  <div class="mobile-dropdown-title">Events</div>
                </div>
                <div class="mobile-dropdown-item" @click="navigateTo('/insights')">
                  <div class="mobile-dropdown-title">Blog</div>
                </div>
                <div class="mobile-dropdown-item" @click="navigateTo('/customers')">
                  <div class="mobile-dropdown-title">Customer Stories</div>
                </div>
                <div class="mobile-dropdown-item" @click="navigateTo('/podcasts')">
                  <div class="mobile-dropdown-title">Podcasts</div>
                </div>
              </div>
            </div>

            <!-- About -->
            <div class="mobile-nav-item">
              <button class="mobile-nav-button" :class="{ 'mobile-nav-active': activeMobileSection === 'about' }" @click="toggleMobileSection('about')">
                About
                <div class="mobile-nav-arrow" :style="{ transform: activeMobileSection === 'about' ? 'rotate(-90deg)' : 'rotate(90deg)' }">
                  <img src="../assets/chevron_right.svg" alt="Arrow">
                </div>
              </button>
              <div class="mobile-dropdown-content" :class="{ 'mobile-dropdown-open': activeMobileSection === 'about' }">
                <div class="mobile-dropdown-item" @click="navigateTo('/about')">
                  <div class="mobile-dropdown-title">About Sela</div>
                </div>
                
                <!-- Partners Section -->
                <div class="mobile-partners-section">
                  <div class="mobile-partners-title">
                    Partners
                  </div>
                  <div class="mobile-partners-grid mobile-partners-open">
                    <div class="mobile-partner-item" @click="navigateToPartner('aws')">
                      <img src="https://selacloud.com/logos/AWS.png" alt="AWS" class="mobile-partner-logo" />
                      <span class="mobile-partner-name">AWS</span>
                    </div>
                    <div class="mobile-partner-item" @click="navigateToPartner('google-cloud')">
                      <img src="https://selacloud.com/logos/Google-Cloud.png" alt="Google Cloud" class="mobile-partner-logo" />
                      <span class="mobile-partner-name">Google Cloud</span>
                    </div>
                    <div class="mobile-partner-item" @click="navigateToPartner('azure')">
                      <img src="https://selacloud.com/logos/Microsoft-Azure.png" alt="Microsoft Azure" class="mobile-partner-logo" />
                      <span class="mobile-partner-name">Microsoft Azure</span>
                    </div>
                    <div class="mobile-partner-item" @click="navigateToPartner('alibaba')">
                      <img src="https://selacloud.com/logos/Alibaba-Cloud.png" alt="Alibaba Cloud" class="mobile-partner-logo" />
                      <span class="mobile-partner-name">Alibaba Cloud</span>
                    </div>
                  </div>
                </div>

                <div class="mobile-dropdown-item" @click="navigateTo('/in-the-news')">
                  <div class="mobile-dropdown-title">Newsroom</div>
                </div>
                <div class="mobile-dropdown-item" @click="navigateTo('/careers')">
                  <div class="mobile-dropdown-title">Careers <span class="hiring-text">We're Hiring!</span></div>
                </div>
              </div>
            </div>

          </div>

          <!-- Mobile CTA -->
          <div class="mobile-menu-cta">
            <button class="mobile-cta-button" @click="navigateToCTA">
              Get Started
              <span class="mobile-cta-arrow MaterialIcons">arrow_right_alt</span>
            </button>
            <p class="mobile-cta-copyright">Copyright © {{ currentYear }} - Sela cloud solution</p>
          </div>

        </div>
      </div>

      <!-- Desktop navigation -->
      <div class="nav-links-wrap" :class="{ opennav: openNav }">
        <div class="nav-btn-wrap" :class="{ navactive: tabNav === i + 1, [item.navClass]: true }"
          v-for="(item, i) in manu" :key="i" @mouseenter="tabNav = i + 1">
          <button @click="handleClick(item)" :class="{
            'router-link-active': $route.path === item.route,
          }" @mouseover="tabNav = i + 1" type="button" class="nav-btn">
            {{ item.title }}
          </button>
          <!-- Desktop dropdown -->
          <div class="drop-nav" v-if="tabNav !== 0" @mouseenter="keepDropdownOpen" @mouseleave="closeNav">
            <div class="drop-nav-list" v-for="(sub, i) in item.sub" :key="i + 'sub'"
              :class="{ 'drop-nav-right': sub.subTitle }">
              <!-- <h3 class="nav-drop-title">{{ sub.title }}</h3> -->
              <p class="nav-drop-txt nomarg" v-if="sub.subTitle">
                {{ sub.subTitle }}
              </p>
              <div class="nav-drop-items">

                <template v-for="subLink in sub.items">
                  <!-- Items with nested sub-navigation -->
                  <div v-if="subLink.sub && subLink.title === 'Partners'" :key="subLink.title" class="nav-drop-item nav-drop-item-with-sub desktop-partners-accordion">

                    <div class="desktop-partners-header" @click="toggleDesktopPartners">
                      <img v-if="subLink.icon && selectIcon(subLink.icon)" :src="selectIcon(subLink.icon)"
                        :alt="subLink.title" />
                      <p class="nav-drop-small-title nav-drop-parent-title partners-title" :style="{ margin: subLink.icon ? '0 0 0 50px' : '0 0 0 0' }">
                        {{ subLink.menuItemLabel || subLink.title }}
                      </p>
                      <div class="desktop-partners-arrow" :class="{ 'desktop-partners-arrow-open': desktopPartnersOpen }">
                        <img src="../assets/chevron_right.svg" alt="Arrow">
                      </div>
                    </div>

                    <!-- Nested sub-items - Desktop Partners Accordion -->
                    <div class="nav-drop-nested desktop-partners-content" :class="{ 'desktop-partners-content-open': desktopPartnersOpen }">
                      <template v-for="nestedItem in subLink.sub">
                        <a v-if="nestedItem.route" :key="nestedItem.title" :to="nestedItem.route" tag="a"
                          :href="nestedItem.route" :target="isAbsoluteUrl(nestedItem.route) ? '_blank' : '_self'"
                          rel="noopener noreferrer" class="nav-drop-nested-item partner-link-item" @click="closeNavWrap()">

                          <img v-if="getPartnerLogo(nestedItem.title)" :src="getPartnerLogo(nestedItem.title)"
                            :alt="nestedItem.title" class="partner-logo-img" />
                          <p class="nav-drop-nested-title">
                            {{ nestedItem.menuItemLabel || nestedItem.title }}
                          </p>
                          <p class="nav-drop-nested-txt">{{ nestedItem.subtitle }}</p>

                        </a>

                        <div v-else :key="nestedItem.title" class="nav-drop-nested-item nav-drop-nested-no-link">
                          <img v-if="getPartnerLogo(nestedItem.title)" :src="getPartnerLogo(nestedItem.title)"
                            :alt="nestedItem.title" class="partner-logo-img" />
                          <p class="nav-drop-nested-title">
                            {{ nestedItem.menuItemLabel || nestedItem.title }}
                          </p>
                          <p class="nav-drop-nested-txt">{{ nestedItem.subtitle }}</p>
                        </div>
                      </template>
                    </div>

                  </div>

                  <!-- Items with nested sub-navigation (non-Partners) -->
                  <div v-else-if="subLink.sub" :key="subLink.title" class="nav-drop-item nav-drop-item-with-sub">

                    <img v-if="subLink.icon && selectIcon(subLink.icon)" :src="selectIcon(subLink.icon)"
                      :alt="subLink.title" />
                    <p class="nav-drop-small-title nav-drop-parent-title partners-title" :style="{ margin: subLink.icon ? '0 0 0 50px' : '0 0 0 0' }">
                      {{ subLink.menuItemLabel || subLink.title }}
                    </p>
                    <p class="nav-drop-txt">{{ subLink.subtitle }}</p>

                    <!-- Nested sub-items -->
                    <div class="nav-drop-nested">
                      <template v-for="nestedItem in subLink.sub">
                        <a v-if="nestedItem.route" :key="nestedItem.title" :to="nestedItem.route" tag="a"
                          :href="nestedItem.route" :target="isAbsoluteUrl(nestedItem.route) ? '_blank' : '_self'"
                          rel="noopener noreferrer" class="nav-drop-nested-item partner-link-item" @click="closeNavWrap()">

                          <img v-if="getPartnerLogo(nestedItem.title)" :src="getPartnerLogo(nestedItem.title)"
                            :alt="nestedItem.title" class="partner-logo-img" />
                          <p class="nav-drop-nested-title">
                            {{ nestedItem.menuItemLabel || nestedItem.title }}
                          </p>
                          <p class="nav-drop-nested-txt">{{ nestedItem.subtitle }}</p>

                        </a>

                        <div v-else :key="nestedItem.title" class="nav-drop-nested-item nav-drop-nested-no-link">
                          <img v-if="getPartnerLogo(nestedItem.title)" :src="getPartnerLogo(nestedItem.title)"
                            :alt="nestedItem.title" class="partner-logo-img" />
                          <p class="nav-drop-nested-title">
                            {{ nestedItem.menuItemLabel || nestedItem.title }}
                          </p>
                          <p class="nav-drop-nested-txt">{{ nestedItem.subtitle }}</p>
                        </div>
                      </template>
                    </div>

                  </div>

                  <!-- Link items with routes (no sub-navigation) -->
                  <a v-else-if="subLink.route" :key="subLink.title" :to="subLink.route" tag="a"
                    :href="subLink.route" :target="isAbsoluteUrl(subLink.route) ? '_blank' : '_self'"
                    rel="noopener noreferrer" class="nav-drop-item" @click="closeNavWrap()">

                    <img v-if="subLink.icon && selectIcon(subLink.icon)" :src="selectIcon(subLink.icon)"
                      :alt="subLink.title" />
                    <p class="nav-drop-small-title" :style="{ margin: subLink.icon ? '0 0 0 50px' : '0 0 0 0' }">
                      <template v-if="subLink.title === 'Careers'">
                        {{ subLink.menuItemLabel || subLink.title }} <span class="hiring-text">We're Hiring!</span>
                      </template>
                      <template v-else>
                        {{ subLink.menuItemLabel || subLink.title }}
                      </template>
                    </p>
                    <p class="nav-drop-txt">{{ subLink.subtitle }}</p>

                  </a>

                  <!-- Non-link items without routes or sub-navigation -->
                  <div v-else :key="subLink.title" class="nav-drop-item nav-drop-item-no-link">

                    <img v-if="subLink.icon && selectIcon(subLink.icon)" :src="selectIcon(subLink.icon)"
                      :alt="subLink.title" />
                    <p class="nav-drop-small-title" :style="{ margin: subLink.icon ? '0 0 0 50px' : '0 0 0 0' }">
                      {{ subLink.menuItemLabel || subLink.title }}
                    </p>
                    <p class="nav-drop-txt">{{ subLink.subtitle }}</p>

                  </div>
                </template>

              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Desktop CTA - show only on desktop -->
      <div class="cont-nav desktop-cta">
        <a 
          href="/contact" 
          class="animated-button"
          @mouseenter="handleMouseEnter"
          @focusin="handleFocus"
          :style="{
            '--circle-x': `${circleX}%`,
            '--circle-y': `${circleY}%`
          }"
        >
          <span class="button-text">Get Started</span>
          <span class="button-arrow MaterialIcons">arrow_right_alt</span>
        </a>
      </div>
    </div>
    <div class="gradLine"></div>
  </div>
</template>

<script>

import { buildPath } from "@/utils/buildPath";

export default {
  data() {
    return {
      circleX: 50,
      circleY: 50,
      currentYear: new Date().getFullYear(),
      mobileMenuOpen: false,
      activeMobileSection: null,
      desktopPartnersOpen: false,
      manu: [
        {
          title: "Services",
          navClass: "smallerwrap",
          sub: [
            {
              items: [
                {
                  title: "Cloud Management Services",
                  route: "/support",
                },
                {
                  title: "DevOps",
                  route: "/solutions/devops-as-a-service",
                },
                {
                  title: "Security",
                  route: "/solutions/security",
                },
                {
                  title: "Cloud Architecture",
                  route: "/solutions/cloud-architecture",
                },
                {
                  title: "Cloud Migration & Modernization",
                  route: "/solutions/cloud-migration",
                },
                {
                  title: "Data & AI",
                  route: "/solutions/revolutionize-your-business-with-ai-cloud-services",
                },
                {
                  title: "FinOps",
                  route: "/solutions/finops-as-a-service",
                },
                {
                  title: "Support & Monitoring Managed Services",
                  route: "/solutions/monitoring-support-as-a-service",
                },
                {
                  title: "Delivery: Staff Augmentation, Offshoring",
                  route: "/solutions/delivery-professional-services-staff-augmentation",
                },
                {
                  title: "Skilling",
                  route: "/skilling",
                },
              ],
            },
          ],
        },
        {
          title: "Solutions",
          navClass: "smallerwrap",
          sub: [
            {
              items: [
                {
                  title: "GenAI Adoption Solution",
                  route: "/solutions/genai-adoption",
                },
                {
                  title: "AI Chatbot over Company Data",
                  route: "/solutions/ai-chatbot-company-data",
                },
                {
                  title: "Marketplace Solutions",
                  route: "/solutions/marketplace",
                },
                {
                  title: "Landing Zones Solutions",
                  route: "/solutions/landing-zones",
                },
              ],
            },
          ],
        },
        {
          title: "Resources",
          navClass: "smallerwrap",
          sub: [
            {
              items: [
                {
                  title: "Events",
                  route: "/events",
                },
                {
                  title: "Blog",
                  route: "/insights",
                },
                {
                  title: "Customer Stories",
                  route: "/customers",
                },
                {
                  title: "Podcasts",
                  route: "/podcasts",
                },
              ],
            },
          ],
        },
        {
          title: "About",
          navClass: "smallerwrap",
          sub: [
            {
              items: [
                {
                  title: "About Sela",
                  route: "/about",
                },
                {
                  title: "Partners",
                  sub:[
                    {
                      title: "AWS",
                      route: "/aws",
                    },
                    {
                      title: "Google Cloud",
                      route: "/google-cloud",
                    },
                    {
                      title: "Microsoft Azure",
                      route: "/azure",
                    },
                    {
                      title: "Alibaba Cloud",
                      route: "/alibaba",
                    },
                  ]
                },
                {
                  title: "Newsroom",
                  route: "/in-the-news",
                },
                {
                  title: "Careers",
                  route: "/careers",
                },
              ],
            },
          ],
        },
      ],
      tabNav: 0,
      openNav: false,
    };
  },
  watch: {
    "$route.path"() {
      this.tabNav = 0;
    },
    "$route.hash"() {
      this.tabNav = 0;
    },
  },
  mounted() {
    this.listenToHover();
  },
  methods: {
    handleMouseEnter(event) {
      const button = event.currentTarget;
      const rect = button.getBoundingClientRect();
      
      // חישוב מיקום יחסי של העכבר בתוך הכפתור (באחוזים)
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      
      this.circleX = x;
      this.circleY = y;
    },
    handleFocus() {
      // עבור accessibility - שימוש במיקום מרכזי
      this.circleX = 50;
      this.circleY = 50;
    },
    handleClick(item) {
      if (item.route) {
        this.$router.push(item.route);
      }
    },
    toggleDesktopPartners() {
      this.desktopPartnersOpen = !this.desktopPartnersOpen;
    },
    selectIcon(iconName) {
      if (typeof iconName === "object") return iconName.imageURL;
      const icon = require.context("../assets/icons/");
      try {
        return icon(`./${iconName}.svg`);
      } catch (err) {
        return "";
      }
    },
    getPartnerLogo(partnerName) {
      const logoMap = {
        'AWS': '/logos/AWS.png',
        'Google Cloud': '/logos/Google-Cloud.png',
        'Microsoft Azure': '/logos/Microsoft-Azure.png',
        'Alibaba Cloud': '/logos/Alibaba-Cloud.png'
      };
      return logoMap[partnerName] || null;
    },
    listenToHover() {
      document.querySelectorAll(".closeOnHover").forEach((e) => {
        e.addEventListener("mouseenter", () => {
          this.tabNav = 0;
        });
      });
    },
    keepDropdownOpen() {
      // שמירה על הדרופדאון פתוח כשהעכבר עליו
    },
    closeNav() {
      this.tabNav = 0;
      this.openNav = false;
    },
    closeNavWrap() {
      const el = document.querySelector(".opennav");
      el.classList = [...el.classList].filter(x => x != "opennav");
    },
    closeMobileNav() {
      this.openNav = false;
      this.tabNav = 0;
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false;
      this.activeMobileSection = null;
    },
    toggleMobileSection(section) {
      if (this.activeMobileSection === section) {
        this.activeMobileSection = null;
      } else {
        this.activeMobileSection = section;
      }
    },
    navigateTo(route) {
      this.$router.push(route);
      this.closeMobileMenu();
    },
    navigateToPartner(partner) {
      // Handle partner navigation
      const partnerRoutes = {
        'aws': 'https://aws.amazon.com',
        'google-cloud': 'https://cloud.google.com',
        'azure': 'https://azure.microsoft.com',
        'alibaba': 'https://alibabacloud.com'
      };
      
      if (partnerRoutes[partner]) {
        window.open(partnerRoutes[partner], '_blank');
      }
      this.closeMobileMenu();
    },
    navigateToCTA() {
      window.open('/contact', '_blank');
      this.closeMobileMenu();
    },
    isAbsoluteUrl(route) {
      return route && /^https?:\/\//i.test(route);
    },
    buildPath
  },
  name: "topnav",
};
</script>
<style scoped>
.logo-wrap img{
  height: 30px;
  margin-top: -1px;
}
/* Animated Button Styles */
.animated-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  /* padding: 12px 24px; */
  padding: 8px 16px;
  position: relative;
  overflow: hidden;
  border: 1px solid #333;
  color: #333;
  cursor: pointer;
  font-size: 18px;
  font-family: inherit;
  border-radius: 10px;
  transition: color 0.4s ease;
  text-decoration: none;
  background: transparent;
  font-weight: 300;
  height: 40px;
}

/* העיגול השחור שגדל ממיקום העכבר */
.animated-button::before {
  content: '';
  position: absolute;
  top: var(--circle-y, 50%);
  left: var(--circle-x, 50%);
  width: 0;
  height: 0;
  background-color: #333;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.4s ease, height 0.4s ease, opacity 0.4s ease;
  z-index: 1;
  opacity: 0;
}

.animated-button:hover::before {
  width: 400px;
  height: 400px;
  opacity: 1;
}
.button-text{
  line-height: 0 !important;
}

.animated-button:hover {
  color: #fff;
}

.animated-button:hover .button-text,
.animated-button:hover .button-arrow {
  color: #fff;
}

.button-text,
.button-arrow {
  position: relative;
  z-index: 2;
  transition: color 0.4s ease;
  margin: 0;

}

.button-arrow {
  /* font-size: 32px; */
  font-size: 1.5rem;
  font-weight: 100 !important;
  line-height: 0.8;
  transition: transform 0.3s ease, color 0.4s ease;
    font-weight: 250 !important;
  font-variation-settings:
    'wght'250 !important;
}

.animated-button:hover .button-arrow {
  transform: translateX(3px);
}
.mobile-cta{
  display: none;
}

  .nav-links-wrap {
    display: flex;
    margin-inline-start: -0.5rem;
  }

@media screen and (max-width: 910px) {
  .button-text{
  line-height: unset !important;
}
  .animated-button {
    padding: 4px 20px;
    font-size: 14px;
    font-weight: 400;
    margin-inline-start: auto;
  }
  
  .button-arrow {
    font-size: 16px;
  }
}

/* Mobile Navigation Styles - New Design */
@media screen and (max-width: 910px) {
  .topnav {
    position: relative;
    padding: 0.5rem 0.5rem;
    background: white;
    border-bottom: 1px solid #e5e7eb;
  }

  .logo-wrap img {
    height: 30px;
  }

  /* Mobile overlay menu */
  .mobile-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    z-index: 9998;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
  }

  .mobile-menu-overlay.mobile-menu-open {
    opacity: 1;
    visibility: visible;
  }

  /* Mobile menu container */
  .mobile-menu-container {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.9);
    width: calc(100% - 2rem);
    max-width: 600px;
    height: calc(100vh - 2rem);
    background: white;
    border-radius: 24px;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    z-index: 9999;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    overflow: hidden;
    border: 1px solid #2D3034;
  }

  .mobile-menu-container.mobile-menu-open {
    opacity: 1;
    visibility: visible;
    transform: translate(-50%, -50%) scale(1);
  }

  /* Hide desktop navigation on mobile */
  .nav-links-wrap {
    display: none;
  }

  /* Mobile menu header */
  .mobile-menu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1rem;
    background: #f5f8fa;
    border-bottom: 1px solid #2D3034;

  }
  .mobile-menu-cta{
    padding: 1rem 2rem;
    background: #f5f8fa;
    border-top: 1px solid #2D3034;
  }

  .mobile-menu-logo {
    height: 20px;
  }

  .mobile-close-btn {
    width: 32px;
    height: 32px;
    background: transparent;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    font-size: 18px;
    color: #6b7280;
  }

  .mobile-close-btn:hover {
    /* background: #f3f4f6; */
    transform: rotate(90deg);
  }

  /* Mobile menu content */
  .mobile-menu-content {
    padding: 0 30px;
    height: calc(100vh - 13.5rem);
    overflow-y: auto;
  }

  /* Mobile navigation items */
  .mobile-nav-item {
    border-bottom: 1px solid #b7b7b7;
    padding-block: 1rem;
  }

  .mobile-nav-button {
    width: 100%;
    background: none;
    border: none;
    padding:0rem 0.5rem;
    text-align: left;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #111827;
    transition: all 0.2s ease;
    border-left: 4px solid transparent;

  }

  .mobile-nav-button.mobile-nav-active {
    /* background: #f0fdff; */
    /* color: var(--primary); */
    border-left: 4px solid var(--primary);
  }

  .mobile-nav-arrow {
    font-size: 20px;
    color: #374151;
    transition: transform 0.3s ease;
    transform-origin: center center;
    display: inline-block;
    line-height: 0;
    /* font-weight: bold; */
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
  }


  /* Mobile dropdown content */
  .mobile-dropdown-content {
    /* background: #f9fafb; */
    padding-inline: 0.75rem;
    max-height: 0;
    overflow: hidden;
    transition:all 0.3s ease;
  }

  .mobile-dropdown-content.mobile-dropdown-open {
    max-height: 500px;
        padding: 0.75rem;

  }

  .mobile-dropdown-item {
    padding: 0.5rem 0;
    /* border-bottom: 1px solid #f3f4f6; */
    /* cursor: pointer; */
    transition: all 0.2s ease;
    font-size: 14px;
  }

  /* .mobile-dropdown-item:last-child {
    border-bottom: none;
  } */

  /* .mobile-dropdown-item:hover {
    background: white;
    padding-left: 2.5rem;
  } */

  .mobile-dropdown-title {
    font-size: 16px;
    font-weight: 300;
    color: #374151;
    margin-bottom: 0.25rem;
  }

  .mobile-dropdown-subtitle {
    font-size: 14px;
    color: #6b7280;
    line-height: 1.4;
  }

  /* Partners section styling */
  .mobile-partners-section {
    /* background: #f9fafb; */
    padding: 0.5rem 0.5rem 1rem 0.5rem;
    /* border-top: 1px solid #f3f4f6; */
  }

  .mobile-partners-title {
    font-size: 16px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 1rem;
  }

  .mobile-partners-grid {
    display: grid;
    gap: 0.75rem;
  }

  .mobile-partner-item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding-inline-start: 0.75rem;
    background: white;
    /* border: 1px solid #f3f4f6; */
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .mobile-partner-item:hover {
    border-color: var(--primary);
    box-shadow: 0 4px 12px rgba(0, 219, 233, 0.15);
    transform: translateY(-2px);
  }

  .mobile-partner-logo {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  .mobile-partner-name {
    font-size: 14px;
    font-weight: 300;
    color: #374151;
  }

  /* Mobile CTA button */


  .mobile-cta-button {
    background: var(--primary);
    color: #2D3034;
    border: none;
    padding: 0.5rem 1.5rem;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 300;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    transition: all 0.2s ease;
    border: 1px solid #2D3034;
  }

  .mobile-cta-button:hover {
    background: #0099cc;
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 219, 233, 0.3);
  }

  .mobile-cta-arrow {
    font-size: 22px;
    transition: transform 0.2s ease;
  }

  .mobile-cta-button:hover .mobile-cta-arrow {
    transform: translateX(4px);
  }

  /* Mobile hamburger menu button */
  .mobile-hamburger-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 8px;
    transition: all 0.2s ease;
    width: 40px;
    height: 40px;
  }

  .mobile-hamburger-btn:hover {
    background: #f9fafb;
  }
  .mobile-cta-copyright{
    font-size: 12px;
  }
  .mobile-hamburger-lines {
    width: 18px;
    height: 25px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .mobile-hamburger-line {
    width: 100%;
    height: 1px;
    background: #374151;
    border-radius: 1px;
    transition: all 0.3s ease;
  }
  .mobile-cta{
    display: flex;
  }
}

/* Hide mobile menu on desktop */
@media screen and (min-width: 911px) {
  .mobile-hamburger-btn,
  .mobile-menu-overlay,
  .mobile-menu-container {
    display: none;
  }
}

/* Hide desktop navigation on mobile */
@media screen and (max-width: 910px) {
  .nav-links-wrap,
  .desktop-cta {
    display: none;
  }
}

.gradLine {
	height: 1px;
	background: linear-gradient(90deg,  transparent 0%, var(--black) 50%,transparent  100% );
}
.nav-drop-img{
  margin: 10px;
}
.nav-drop-img:hover{
  filter: brightness(90%);
}

/* Parent item with nested sub-navigation */
.nav-drop-item-with-sub {
  position: relative;
  padding-bottom: 8px;
}

/* Parent title styling */
.nav-drop-parent-title {
  font-weight: 600;
  color: #333;
  margin-bottom: 8px !important;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 4px;
}

/* Partners title - allow normal hover effects */
.partners-title {
  cursor: default;
  font-weight: 500 !important;
  color: #666 !important;
  border-bottom: 1px solid transparent !important;
}

/* Partner logo styling */
.partner-logo-img {
  width: 20px;
  height: 20px;
  object-fit: contain;
  margin-inline-start: 8px;
}

/* Partner link items with hover effects */
.partner-link-item {
  display: flex;
  align-items: center;
  gap: 0rem;
  padding: 4px 0;
  text-decoration: none;
  color: inherit;
  transition: background-color 0.2s ease;
  margin-bottom: 4px;
  border-left: 4px solid transparent;
}

/* Add blue border only when hovering directly on the partner item */
.partner-link-item:hover {
  background-color: #f8f9fa;
  text-decoration: none;
  border-left: 4px solid var(--primary);
}

/* Prevent parent hover from affecting children */
.nav-drop-item-with-sub:hover .partner-link-item {
  border-left: 4px solid transparent;
  background-color: transparent;
}

/* But allow direct hover on children to work */
.nav-drop-item-with-sub .partner-link-item:hover {
  background-color: #f8f9fa !important;
  border-left: 4px solid var(--primary) !important;
}

.partner-link-item:hover .nav-drop-nested-title {
  font-weight: 600;
}

/* Container for nested items */
.nav-drop-nested {
  margin-left: 1rem;
  margin-top: 8px;
}

/* Individual nested item styling - general */
.nav-drop-nested-item:not(.partner-link-item) {
  display: block;
  padding: 6px 0;
  text-decoration: none;
  color: inherit;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  margin-bottom: 4px;
}

.nav-drop-nested-item:not(.partner-link-item):hover {
  background-color: #f8f9fa;
  text-decoration: none;
}

/* Nested item titles */
.nav-drop-nested-title {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 2px 0 !important;
  color: #555;
}

/* Nested item subtitles */
.nav-drop-nested-txt {
  font-size: 12px;
  color: #888;
  margin: 0 !important;
  line-height: 1.3;
}

/* Non-clickable nested items */
.nav-drop-nested-no-link {
  cursor: default;
}

.nav-drop-nested-no-link:hover {
  background-color: transparent;
}

.nav-drop-nested-no-link .nav-drop-nested-title {
  color: #888;
}

/* Hiring text styling */
.hiring-text {
  color: var(--primary) !important;
  font-weight: 600;
}

/* Desktop Partners Accordion Styles */
.desktop-partners-accordion {
  position: relative;
  margin-bottom: -1rem;
}

.desktop-partners-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 4px 0 0;
  transition: background-color 0.2s ease;
  border-radius: 4px;
  width: 100px;
}

.desktop-partners-header:hover {
  background-color: #f8f9fa;
}

.desktop-partners-arrow {
  width: 16px;
  height: 16px;
  transition: transform 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.desktop-partners-arrow img {
  width: 12px;
  height: 12px;
  transition: transform 0.3s ease;
}

.desktop-partners-arrow-open {
  transform: rotate(90deg);
}

.desktop-partners-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease;
  opacity: 0;
  padding: 0;
}

.desktop-partners-content-open {
  max-height: 300px;
  opacity: 1;
  padding-top: 8px;
}

/* Override Partners title styling for desktop accordion */
.desktop-partners-accordion .partners-title {
  border-bottom: none !important;
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
  cursor: pointer !important;
  flex: 1;
}

</style>